import React from "react";

const dummyComments = [
	{
		name: "Krystho Amara Pratama, S.Pd.",
		date: "9 Agustus 2024 · 14:11",
		content:
			"Platform JMD ini sangat bagus. Kami bisa langsung merasakan manfaatnya di madrasah kami. Saya berharap ke depan fiturnya makin lengkap.",
	},
	{
		name: "Aldo Raisy Mahendra, S.Pd.",
		date: "1 Agustus 2024 · 10:47",
		content:
			"Kedatangan tim Jogja Madrasah Digital ini merupakan kesempatan besar untuk meningkatkan kualitas sistem manajemen di madrasah kami. Cybermadrasah sangat mudah untuk digunakan.",
	},
	{
		name: "Zahra Nabila Azzahra, S.Pd.",
		date: "28 Juli 2024 · 09:23",
		content:
			"Saya sangat senang dengan kemudahan fitur presensi online. Platform ini benar-benar membuat proses administrasi menjadi lebih efisien.",
	},
];

function KomentarSection() {
	const handleSubmit = (e) => {
		e.preventDefault();
		alert("Fitur komentar belum tersedia");
	};

	return (
		<div className="mt-10">
			{/* Divider */}
			<div className="h-px bg-gray-200 mb-8" />

			{/* Comments List */}
			<div className="mb-10">
				<h3 className="text-xl font-bold text-gray-800 mb-6 flex items-center gap-2">
					<svg
						className="w-5 h-5 text-green-600"
						fill="none"
						stroke="currentColor"
						viewBox="0 0 24 24"
					>
						<path
							strokeLinecap="round"
							strokeLinejoin="round"
							strokeWidth={2}
							d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z"
						/>
					</svg>
					Komentar
				</h3>

				<div className="space-y-6">
					{dummyComments.map((comment, idx) => (
						<div
							key={idx}
							className="flex gap-4 p-4 rounded-xl bg-gray-50/50 border border-gray-100"
						>
							{/* Avatar placeholder */}
							<div className="w-10 h-10 rounded-full bg-gradient-to-br from-green-400 to-green-600 flex items-center justify-center text-white font-bold text-sm flex-shrink-0">
								{comment.name.charAt(0)}
							</div>
							<div className="flex-1">
								<div className="flex items-baseline gap-2 mb-1">
									<span className="font-semibold text-gray-800 text-sm">
										{comment.name}
									</span>
									<span className="text-xs text-gray-400">{comment.date}</span>
								</div>
								<p className="text-gray-600 text-sm leading-relaxed">
									{comment.content}
								</p>
							</div>
						</div>
					))}
				</div>
			</div>

			{/* Comment Form */}
			<div className="bg-white rounded-2xl p-6 border border-gray-200">
				<h4 className="text-lg font-bold text-gray-800 mb-5 flex items-center gap-2">
					<svg
						className="w-5 h-5 text-green-600"
						fill="none"
						stroke="currentColor"
						viewBox="0 0 24 24"
					>
						<path
							strokeLinecap="round"
							strokeLinejoin="round"
							strokeWidth={2}
							d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
						/>
					</svg>
					Tinggalkan Komentar
				</h4>

				<div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
					<div>
						<label className="block text-sm font-medium text-gray-600 mb-1.5">
							Masukkan Nama
						</label>
						<input
							type="text"
							placeholder="Nama lengkap Anda"
							className="w-full bg-gray-50 border border-gray-200 rounded-xl px-4 py-3 text-sm text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-green-500/30 focus:border-green-400 transition-all duration-200"
						/>
					</div>
					<div>
						<label className="block text-sm font-medium text-gray-600 mb-1.5">
							Masukkan Email
						</label>
						<input
							type="email"
							placeholder="email@contoh.com"
							className="w-full bg-gray-50 border border-gray-200 rounded-xl px-4 py-3 text-sm text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-green-500/30 focus:border-green-400 transition-all duration-200"
						/>
					</div>
				</div>

				<div className="mb-4">
					<label className="block text-sm font-medium text-gray-600 mb-1.5">
						Tulis Komentar
					</label>
					<textarea
						rows={4}
						placeholder="Tulis komentar Anda di sini..."
						className="w-full bg-gray-50 border border-gray-200 rounded-xl px-4 py-3 text-sm text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-green-500/30 focus:border-green-400 transition-all duration-200 resize-none"
					/>
				</div>

				<button
					onClick={handleSubmit}
					className="inline-flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white font-semibold px-6 py-3 rounded-xl shadow-lg shadow-green-600/20 transition-all duration-300 hover:shadow-xl text-sm"
				>
					<svg
						className="w-4 h-4"
						fill="none"
						stroke="currentColor"
						viewBox="0 0 24 24"
					>
						<path
							strokeLinecap="round"
							strokeLinejoin="round"
							strokeWidth={2}
							d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"
						/>
					</svg>
					Posting Komentar
				</button>
			</div>
		</div>
	);
}

export default KomentarSection;
